import React, { useState, useEffect, useCallback } from 'react';
import { getData, updateData } from '../../services/socialLinksServices';
import { Button, Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const SocialLinks = () => {
  const [form, setForm] = useState({ id: '', fb_link: '', in_link: '', twitter_link: '', youtube_link: '' });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  // Fetch data
  const fetchData = useCallback(async () => {
  setLoading(true);
    try {
      const data = await getData();
      if (data && data.length > 0) {
        setForm(data[0]); // Assuming there's only one record to edit
      }
    } catch (error) { 
          console.error('Error fetching data:', error);
    }
    finally {
      setTimeout(() => {
      setLoading(false);
      }, 500);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  // Validate form data
    const validateForm = () => {
    const newErrors = {};
    const urlPattern = new RegExp(
    "^(https?:\\/\\/)" + // protocol required
    "((([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})|" + // domain...
    "localhost|" + // or localhost
    "\\d{1,3}(\\.\\d{1,3}){3})" + // ...or IPv4
    "(\\:\\d+)?(\\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$"
    );

  const checkUrlWithDomain = (url, domain) => {
    if (!urlPattern.test(url)) return false;
    try {
      const parsed = new URL(url);
      return parsed.hostname.includes(domain);
      } catch {
        return false;
      }
    };

  // Facebook
  if (!form.fb_link) {
    newErrors.fb_link = "Facebook link is required";
  } else if (!checkUrlWithDomain(form.fb_link, "facebook.com")) {
    newErrors.fb_link = "Enter a valid Facebook URL (e.g., https://facebook.com/yourprofile)";
  }

  // LinkedIn
  if (!form.in_link) {
    newErrors.in_link = "LinkedIn link is required";
  } else if (!checkUrlWithDomain(form.in_link, "linkedin.com")) {
    newErrors.in_link = "Enter a valid LinkedIn URL (e.g., https://linkedin.com/in/yourprofile)";
  }

  // Twitter
  if (!form.twitter_link) {
    newErrors.twitter_link = "Twitter link is required";
  } else if (!checkUrlWithDomain(form.twitter_link, "twitter.com")) {
    newErrors.twitter_link = "Enter a valid Twitter URL (e.g., https://twitter.com/yourhandle)";
  }

  // Instagram
  if (!form.youtube_link) {
    newErrors.youtube_link = "";
  } else if ( form.youtube_link && !checkUrlWithDomain(form.youtube_link, "youtube.com")) {
    newErrors.youtube_link = "Enter a valid youtube URL (e.g., https://youtube.com/yourprofile)";
  }
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
  }

  // Handle input change
  const handleChange = (e) => {
    try{
        const { name, value } = e.target;
          // Create a copy of the current form data
          let updatedData = { ...form };
          let updatedErrors = { ...errors };
          updatedData[name] = value;
          if (value) {
          updatedErrors[name] = ''; // Clear error if corrected
        }
        setForm(updatedData);
        setErrors(updatedErrors);
      }
      catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  // Handle form submission (update details)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
        return
      }
    try {
      const result = await updateData(form);
      if (result.status === 200) {
          fetchData();
          toast.success("Updated Successfully!", { position: 'top-right',autoClose: 3000});
      } else {
          toast.error(result.message ||"Failed to Added data. Please try again.", {position: 'top-right',autoClose: 3000});
      }
      fetchData(); // Refresh data after update
      
    } catch (error) {
      console.error('Error updating data:', error);
    }
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Footer Details <b>/ Social Links</b></p>
            </div>
            <div className="col-4 text-end">
              {/* <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button> */}
            </div>
          </div>
          {/* <h2 className='mb-3'>Social Links</h2> */}
          <Form>
          <div className="row">
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Facebook <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="fb_link"
                value={form.fb_link}
                onChange={handleChange}
                isInvalid = {!!errors.fb_link}
              />
              <Form.Control.Feedback type="invalid">{errors.fb_link}</Form.Control.Feedback> 
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Linkedin<small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="in_link"
                value={form.in_link}
                onChange={handleChange}
                isInvalid = {!!errors.in_link}
              />
              <Form.Control.Feedback type="invalid">{errors.in_link}</Form.Control.Feedback> 

            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Twitter <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="twitter_link"
                value={form.twitter_link}
                onChange={handleChange}
                isInvalid = {!!errors.twitter_link}
              />
              <Form.Control.Feedback type="invalid">{errors.twitter_link}</Form.Control.Feedback> 

            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Youtube</Form.Label>
              <Form.Control
                type="text"
                name="youtube_link"
                value={form.youtube_link}
                onChange={handleChange}
                isInvalid = {!!errors.youtube_link}
              />
              <Form.Control.Feedback type="invalid">{errors.youtube_link}</Form.Control.Feedback> 
            </Form.Group>
            </div>
            <Button variant="success" onClick={handleSubmit}>Submit</Button>
          </Form>
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default SocialLinks;
